export default {"src":"/_next/static/media/brand.e9d571bd.svg","height":77,"width":225,"blurWidth":0,"blurHeight":0};